import * as React from "react";
import DashboardOverViewManager from "./DashboardOverViewManager";
import DashboardRankingManager from "./DashboardRankingManager";

import ModernCard from "../../core/ModernCard";

import { useState } from "react";
import DashboardHeader from "./DashboardHeader";
import usePromise from "../../hooks/usePromise";
import { getEmployeeListCommissions } from "../../../libs/commission_calculator";
import * as Sentry from "@sentry/browser";
import { toast } from "../../../utils";
import Loader from "../../core/Loader";

function CommissionDashboardManager({ salespeople }) {
  const [currentView, setCurrentView] = useState("overviewReport");
  const [loading, setLoading] = useState(true);

  const [commissionsAll] = usePromise(async () => {
    if (salespeople && salespeople.length > 0) {
      try {
        const result = await getEmployeeListCommissions({
          users: salespeople.map(obj => obj.id),
        });
        setLoading(false);
        return result;
      } catch (e) {
        toast.error("Error retrieving commissions");
        Sentry.captureException(e);
        setLoading(false);
      }
    } else {
      return new Promise(() => null);
    }
  }, [salespeople]);
  const viewProps = {
    salespeople: salespeople,
    commissionsAll: commissionsAll,
  };
  const views = {
    overviewReport: <DashboardOverViewManager {...viewProps} />,
    rankingReport: <DashboardRankingManager {...viewProps} />,
  };
  const dashboardOptions = [
    { label: "Overview Report", value: "overviewReport" },
    { label: "Ranking Report", value: "rankingReport" },
  ];
  return (
    <ModernCard title="Dashboard" ta="left" m="0px">
      {loading ? (
        <Loader />
      ) : commissionsAll &&
        Array.isArray(commissionsAll) &&
        commissionsAll.length ? (
        <>
          <DashboardHeader
            title={
              dashboardOptions.find(obj => obj.value === currentView)["label"]
            }
            menuOptions={dashboardOptions}
            currentView={currentView}
            setCurrentView={setCurrentView}
          />
          {views[currentView]}
        </>
      ) : (
        <div> No commissions found </div>
      )}
    </ModernCard>
  );
}

export default CommissionDashboardManager;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/dashboard/CommissionDashboardManager.tsx